// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — settingslimits.styled.classic.js, новая — settingslimits.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './settingslimits.styled.classic';
import * as cp from './settingslimits.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Item = isCp ? cp.Item : classic.Item;
export const ItemButtons = isCp ? cp.ItemButtons : classic.ItemButtons;
export const Title = isCp ? cp.Title : classic.Title;
export const Value = isCp ? cp.Value : classic.Value;
